module.exports = __webpack_public_path__ + "static/img/record.c130839.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/record.png
// module id = dz9f
// module chunks = 6